module.exports = require('./helpers/bundle-url').getBundleURL('53zxi') + "logo.5ec3ca99.svg";